export default [
  {
    name: 'Economía',
    description:
      'La economía, en toda su multitud de enfoques y corrientes, es mi pasión, la cual se ha desarrollado desde la escuela secundaria cuando participé en la Olimpiada. La curiosidad sobre cómo se puede administrar un estado se convirtió en la inspiración para crear mi plataforma de pruebas políticas, Soulgraphy.',
    image: 'kanada',
  },
  {
    name: 'La naturaleza y el mundo animal',
    description:
      'Desde pequeño, me ha fascinado el mundo animal y el entorno en el que viven. De niño, quería ser zoólogo.',
    image: 'seal',
  },
  {
    name: 'Países del mundo',
    description:
      'Cada año me fascina más profundizar en el conocimiento sobre diferentes rincones del mundo. Cómo se han formado los idiomas a lo largo del tiempo ayuda a comprender mejor la cultura y la forma de pensar de las personas de diferentes países. Al sumergirme en su historia, es más fácil ver qué influye en cómo se ve su presente. Estoy particularmente interesado en los países nórdicos y Japón.',
    image: 'japan',
  },
  {
    name: 'Tecnologías electrónicas',
    description:
      'La electrónica, la programación o las tecnologías de telecomunicación no son solo un campo científico interesante para mí. Sobre todo, son herramientas que me permiten sentirme como un inventor y crear de forma independiente mis propios circuitos electrónicos o aplicaciones web.',
    image: 'telecommunications',
  },
  {
    name: 'Física y tecnología',
    description:
      'Siempre he tenido curiosidad por saber cómo funciona el mundo. No importa si es la corriente en una bombilla o por qué brilla el sol. Para mí, la física es el proceso de conocer el mundo y comprender por qué se comporta como lo hace. Utilizar este conocimiento proporciona a mentes brillantes las herramientas para crear soluciones innovadoras que cambian el mundo ante nuestros ojos: desde energía barata y limpia, pasando por baterías eficientes, hasta medicamentos que salvan vidas.',
    image: 'physics',
  },
  {
    name: 'Cocina',
    description:
      'Me encanta cocinar y experimentar en la cocina, y preparar pasta o carne es una parte habitual de mi día. Aparte de la cocina polaca, me encantan los platos coreanos e indios.',
    image: 'cooking',
  },
  {
    name: 'Fantasía, juegos y relajación',
    description:
      'Nadie en su sano juicio vuelve del trabajo a otro trabajo, porque todos necesitamos relajarnos y desconectar de la rutina diaria. Cuando lo hago, suelo ver películas, explorar (y escribir) fantasía, hacer viajes en coche o jugar todo tipo de juegos con amigos.',
    image: 'relax',
  },
]
